import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const ElencoFornitori: React.FC = () => {
  // Percorso del PDF nella cartella public
  const pdfUrl = process.env.PUBLIC_URL + '/pdf/Elenco-fornitori.pdf';
  const [pdfError, setPdfError] = useState(false);

  useEffect(() => {
    // Verifica se il PDF è accessibile
    const checkPdfExists = async () => {
      try {
        const response = await fetch(pdfUrl);
        if (!response.ok) {
          setPdfError(true);
        }
      } catch (error) {
        setPdfError(true);
        console.error("Errore nel caricamento del PDF:", error);
      }
    };
    
    checkPdfExists();
  }, [pdfUrl]);

  return (
    <div className="min-h-screen bg-light-background">
      <Helmet>
        <title>Elenco Fornitori Società Terze | Servizio Bolletta</title>
        <meta name="description" content="Elenco completo dei fornitori e società terze partner di Servizio Bolletta" />
      </Helmet>

      <section className="container mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl md:text-4xl font-bold text-primary mb-8 text-center">
            Elenco Fornitori Società Terze
          </h1>

          <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
            <p className="text-lg mb-6">
              Di seguito è possibile consultare l'elenco completo dei nostri fornitori e società terze partner.
            </p>
            
            <div className="flex flex-col items-center">
              {/* Pulsante per scaricare il PDF */}
              <a 
                href={pdfUrl} 
                download="Elenco-fornitori.pdf"
                className="bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary-dark transition-colors mb-6"
              >
                Scarica PDF
              </a>
              
              {/* Visualizzatore PDF integrato */}
              <div className="w-full h-[600px] border border-gray-300 rounded-lg overflow-hidden">
                {pdfError ? (
                  <div className="flex flex-col items-center justify-center h-full p-8 text-center">
                    <p className="text-xl text-red-600 mb-4">
                      Impossibile caricare il PDF. 
                    </p>
                    <p className="text-gray-600">
                      Se il problema persiste, contatta il supporto tecnico.
                    </p>
                  </div>
                ) : (
                  <object
                    data={pdfUrl}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    className="w-full h-full"
                  >
                    <p>
                      Il tuo browser non supporta la visualizzazione dei PDF.{' '}
                      <a href={pdfUrl} className="text-primary hover:underline">
                        Clicca qui per scaricare il PDF
                      </a>
                    </p>
                  </object>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default ElencoFornitori; 